// extracted by mini-css-extract-plugin
export default {"connectWallet":"ConnectWallet_connectWallet__PiDWI","walletIcon":"ConnectWallet_walletIcon__M3IX-","profile":"ConnectWallet_profile__WoZJ-","icon":"ConnectWallet_icon__AIWFk"};